import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import AppRoutes from './AppRoutes';

//Pages

// import {CreateQuotePage} from 'modules/quotes/pages';

class Router extends Component {
    render() {
        return <BrowserRouter >{this.props.children}</BrowserRouter>;
    }
}

export default Router;



// WEBPACK FOOTER //
// ./src/modules/router/Router.jsx